<template>
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\achievementStudentManual-1.png" alt="" /></div>
                <div>
                    <p>① Ở màn hình khái quát khóa học, nhấn nút [Xác nhận tiến độ], rồi di chuyển đến màn hình Xác nhận tiến độ.</p>
                </div>
                <div><img src="/static\images\vi\newManual\achievementStudentManual-2.png" alt="" /></div>
                <div>
                    <p>② Nhập điều kiện tìm kiếm, nhấn nút [Tìm kiếm], rồi xác nhận kết quả tìm kiếm.</p>
                    <p>③ Nhấn nút [Xuất file], thì kết quả tìm kiếm sẽ được xuất ra dưới dạng file Excel.</p>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {},
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/en/achievementStudent_manual.vue